import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Modal, BlockStack, Button, Banner, Tooltip } from "@shopify/polaris";
import "./index.scss";
import Language from "../../i18n/Language";
import { store } from "../../redux/store";
import { reqGetNewUserPricingPlanList, reqGetSubscription } from "../../api";
import { connect } from "react-redux";
import { setPageData } from "../../redux/actions/getAppPageData";
import utils from "../../utils/utils";
import { computeBestDiscount } from "../../utils/planRateCalc";
const t = Language;

class indexClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // 自定义弹窗内容
            isCustomize: this.props.isCustomize,
            cusTitle: this.props.cusTitle,
            cusServerList: this.props.cusServerList,

            upgradeModalShow: this.props.upgradeModalShow,
            level: this.props.level,
            userinfo: {},
            serversList: [
                {
                    id: 1,
                    status: 0,
                    plan: 1,
                    name: "lmage Compress",
                    func: ["50 images/month", "2000 images/month", "6000~26000 images/month"],
                    desc: "Before a user clicks on a link, they hover their mouse over that link. When a user has hovered for 65ms there is one chance out of two that they will click on that link, so instant.page starts preloading at this moment, leaving on average over 300ms for the page to preload. Before using this function, please enable the",
                    do: "Try",
                    isText: true,
                },
                {
                    id: 2,
                    status: 0,
                    plan: 1,
                    name: "Site Speed Up",
                    func: ["Basic", "Fast⚡", "Rocket⚡⚡"],
                    desc: "Before a user clicks on a link, they hover their mouse over that link. When a user has hovered for 65ms there is one chance out of two that they will click on that link, so instant.page starts preloading at this moment, leaving on average over 300ms for the page to preload. Before using this function, please enable the",
                    do: "Try",
                    isText: true,
                },
                {
                    id: 3,
                    status: 0,
                    plan: 1,
                    name: "Exchange Backlink",
                    func: ["40 quota", "300 quota", "1000 quota"],
                    desc: "Before a user clicks on a link, they hover their mouse over that link. When a user has hovered for 65ms there is one chance out of two that they will click on that link, so instant.page starts preloading at this moment, leaving on average over 300ms for the page to preload. Before using this function, please enable the",
                    do: "Try",
                    isText: true,
                },
                {
                    id: 4,
                    status: 0,
                    plan: 1,
                    name: "On-page SEO Optimization",
                    func: ["20 quota", "1000 quota", "Unlimited quota"],
                    desc: "Before a user clicks on a link, they hover their mouse over that link. When a user has hovered for 65ms there is one chance out of two that they will click on that link, so instant.page starts preloading at this moment, leaving on average over 300ms for the page to preload. Before using this function, please enable the",
                    do: "Try",
                    isText: true,
                },
                {
                    id: 5,
                    status: 0,
                    plan: 1,
                    name: "View page ranking",
                    func: ["10 pages", "500 pages", "1500 pages"],
                    desc: "Before a user clicks on a link, they hover their mouse over that link. When a user has hovered for 65ms there is one chance out of two that they will click on that link, so instant.page starts preloading at this moment, leaving on average over 300ms for the page to preload. Before using this function, please enable the",
                    do: "Try",
                    isText: true,
                },
                {
                    id: 6,
                    status: 0,
                    plan: 1,
                    name: "AI credits",
                    func: ["30 credits", "200 credits/month", "500 credits/month"],
                    desc: "Before a user clicks on a link, they hover their mouse over that link. When a user has hovered for 65ms there is one chance out of two that they will click on that link, so instant.page starts preloading at this moment, leaving on average over 300ms for the page to preload. Before using this function, please enable the",
                    do: "Try",
                    isText: true,
                },
                {
                    id: 14,
                    status: 0,
                    plan: 1,
                    name: "AI Blog Generator",
                    func: [1, 1, 1],
                    desc: "Create SEO-optimized blog posts from keywords in minutes to boost traffic.",
                    do: "Try",
                    isText: false,
                },
                {
                    id: 7,
                    status: 0,
                    plan: 1,
                    name: "Auto repair broken links",
                    func: [0, 1, 1],
                    desc: "Before a user clicks on a link, they hover their mouse over that link. When a user has hovered for 65ms there is one chance out of two that they will click on that link, so instant.page starts preloading at this moment, leaving on average over 300ms for the page to preload. Before using this function, please enable the",
                    do: "Try",
                    isText: false,
                },
                {
                    id: 8,
                    status: 0,
                    plan: 1,
                    name: "Auto-optimization Meta Tags",
                    func: [0, 1, 1],
                    desc: "Before a user clicks on a link, they hover their mouse over that link. When a user has hovered for 65ms there is one chance out of two that they will click on that link, so instant.page starts preloading at this moment, leaving on average over 300ms for the page to preload. Before using this function, please enable the",
                    do: "Try",
                    isText: false,
                },
                {
                    id: 9,
                    status: 0,
                    plan: 1,
                    name: "Google Analytics&instant index",
                    func: [0, 1, 1],
                    desc: "Before a user clicks on a link, they hover their mouse over that link. When a user has hovered for 65ms there is one chance out of two that they will click on that link, so instant.page starts preloading at this moment, leaving on average over 300ms for the page to preload. Before using this function, please enable the",
                    do: "Try",
                    isText: false,
                },
                {
                    id: 10,
                    status: 0,
                    plan: 1,
                    name: "Google structured data&Local Business",
                    func: [0, 1, 1],
                    desc: "Before a user clicks on a link, they hover their mouse over that link. When a user has hovered for 65ms there is one chance out of two that they will click on that link, so instant.page starts preloading at this moment, leaving on average over 300ms for the page to preload. Before using this function, please enable the",
                    do: "Try",
                    isText: false,
                },
                {
                    id: 11,
                    status: 0,
                    plan: 1,
                    name: "AMP",
                    func: [0, 0, 1],
                    desc: "Before a user clicks on a link, they hover their mouse over that link. When a user has hovered for 65ms there is one chance out of two that they will click on that link, so instant.page starts preloading at this moment, leaving on average over 300ms for the page to preload. Before using this function, please enable the",
                    do: "Try",
                    isText: false,
                },
                {
                    id: 12,
                    status: 0,
                    plan: 1,
                    name: "Monitor your website's backlinks&keywords",
                    func: [0, 0, 1],
                    desc: "Before a user clicks on a link, they hover their mouse over that link. When a user has hovered for 65ms there is one chance out of two that they will click on that link, so instant.page starts preloading at this moment, leaving on average over 300ms for the page to preload. Before using this function, please enable the",
                    do: "Try",
                    isText: false,
                },
                {
                    id: 13,
                    status: 0,
                    plan: 1,
                    name: "Advanced competitor keyword research",
                    func: [0, 0, 1],
                    desc: "Before a user clicks on a link, they hover their mouse over that link. When a user has hovered for 65ms there is one chance out of two that they will click on that link, so instant.page starts preloading at this moment, leaving on average over 300ms for the page to preload. Before using this function, please enable the",
                    do: "Try",
                    isText: false,
                },
                {
                    id: 15,
                    status: 0,
                    plan: 1,
                    name: "Keyword Content Planner",
                    func: [0, 1, 1],
                    desc: "Turn one keyword into a complete content strategy with AI-generated topic clusters and page structure.",
                    do: "Try",
                    isText: false,
                },
            ],
            // 价格及升级信息
            userInfo: {},                                        // 用户套餐信息
            proPrice: 1,
            prePrice: 1,
            proId: 1,
            preId: 1,
            proDiscount: 1,
            preDiscount: 1,
            proDiscountPrice: '',
            preDiscountPrice: '',
            proMRecode: '',                                          // 折扣码
            preMRecode: '',
            proYRecode: '',
            preYRecode: '',
            upgradeBtn: false,
            loading: true,
            creditsShow: this.props.creditsShow,
            planInfo: {},
        };
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.level !== this.props.level) {
            this.setState({
                level: nextProps.level
            })
        }
        if (nextProps.upgradeModalShow !== this.props.upgradeModalShow) {
            this.setState({
                upgradeModalShow: nextProps.upgradeModalShow
            }, () => {
                if (nextProps.upgradeModalShow) {
                    this.updCwreportCustomBehavior();
                }
            })
        }
        if (nextProps.creditsShow !== this.props.creditsShow) {
            this.setState({
                creditsShow: nextProps.creditsShow
            })
        }

        return true;
    }

    componentDidMount() {
        let _page = store.getState().page;
        let { isCustomize, serversList, cusServerList } = this.state;
        let newServerList = isCustomize ? cusServerList : serversList;
        this.setState({
            level: _page.level || 1,
            trial_days: _page.trial_days || 0,
            domain: _page.domain || '',
            serversList: newServerList
        }, () => {
            this.getUserPricingPlanList(_page.pageInit?.pricingPlan);
        })
    }

    // 更新posthog埋点
    updCwreportCustomBehavior = () => {
        let res = this.state.pricingData;
        if (res && res?.level !== 3) {
            let planInfo = this.state.planInfo || {
                pro: computeBestDiscount(res, res.meal_list.month[0]),
                pre: computeBestDiscount(res, res.meal_list.month[1]),
            };
            this.props.cwreportCustomBehavior('guide_entry_exposure', {
                source_type: "feature_limit",
                planRes: res,
                planInfo,
                selData: res.level === 1 ? planInfo.pro : planInfo.pre,
            });
        }
    }

    // 获取价格套餐版本
    getUserPricingPlanList = async (cache = null) => {
        let params = {};
        let _actData = store.getState().public.ActMealData;
        if (Object.keys(_actData).length > 0) {
            params['activity_id'] = _actData.activity_id;
            let response = cache || await reqGetNewUserPricingPlanList(params);
            this.props.getPageDataRedux(response);
            if (response.ack === 1) {
                let res = response.data;
                let monthPlan = res.meal_list.month;
                // posthog 弹窗埋点
                let planInfo = {
                    pro: computeBestDiscount(res, res.meal_list.month[0]),
                    pre: computeBestDiscount(res, res.meal_list.month[1]),
                };
                // if (res.level !== 3) {
                //     this.props.cwreportCustomBehavior('guide_entry_exposure', {
                //         source_type: "feature_limit",
                //         planRes: res,
                //         planInfo,
                //         selData: res.level === 1 ? planInfo.pro : planInfo.pre,
                //     });
                // }
                this.setState({
                    pricingPlanList: res.meal_list,
                    loading: false,
                    level: res.level,
                    pricingData: res,
                    userInfo: {
                        ppid: res.ppid,
                        level: res.level,
                        trial_days: res.trial_days
                    },
                    planName: store.getState().public.ActMealData.plan_name || '',
                    isHaveDiscount: res.coupon_fifty_discount,   // 是否存在折扣
                    proPrice: monthPlan[0].price,
                    prePrice: monthPlan[1].price,
                    proId: monthPlan[0].id,
                    preId: monthPlan[1].id,
                    proDiscount: Number(monthPlan[0]?.coupon_info?.rate) === 0 ? '' : Number(monthPlan[0]?.coupon_info?.rate),
                    preDiscount: Number(monthPlan[1]?.coupon_info?.rate) === 0 ? '' : Number(monthPlan[1]?.coupon_info?.rate),
                    proDiscountPrice: (monthPlan[0].discount_exp > new Date().getTime() / 1000) ? (Boolean(monthPlan[0].discount_price) ? (Number(monthPlan[0].discount_price) === 0 ? 0 : Number(monthPlan[0].discount_price)) : -1) : -1,
                    preDiscountPrice: (monthPlan[1].discount_exp > new Date().getTime() / 1000) ? (Boolean(monthPlan[1].discount_price) ? (Number(monthPlan[1].discount_price) === 0 ? 0 : Number(monthPlan[1].discount_price)) : -1) : -1,
                    planInfo,
                }, () => {
                    // 是否更新
                    // if (cache) {
                    //     this.getUserPricingPlanList();
                    // }

                    // 判断优惠力度 计算使用哪个折扣周期
                    let monthProPrice = monthPlan[0].price;
                    let monthPrePrice = monthPlan[1].price;
                    let prodisType = '', predisType = '';
                    let mPro = monthPlan[0], mPre = monthPlan[1];
                    // pro plan
                    if (Boolean(mPro?.discount_period >= 0) && Boolean(mPro?.coupon_info?.discount_period >= 0)) {
                        if (!Boolean(Number(mPro['coupon_info']['rate'])) && Number(mPro['coupon_info']['rate']) < 0) {
                            if (Number(mPro['discount_price']) >= 0) {
                                prodisType = 'discount';
                            }
                        } else if (Number(mPro['coupon_info']['rate']) >= 0 && Number(mPro['coupon_info']['rate']) < 1) {
                            if (Number((Number(Number(mPro['coupon_info']['rate'])) * monthProPrice).toFixed(2)) >= Number(mPro['discount_price']) && Boolean(mPro['discount_price'] >= 0)) {
                                prodisType = 'discount';
                            } else {
                                prodisType = 'code';
                            }
                        } else if (Number(mPro['coupon_info']['rate']) >= 1) {
                            if (Number(monthProPrice - Number(mPro['coupon_info']['rate'])) >= Number(mPro['discount_price']) && Boolean(mPro['discount_price'] >= 0)) {
                                prodisType = 'discount';
                            } else {
                                prodisType = 'code';
                            }
                        } else {
                            prodisType = '';
                        }
                    } else {
                        if (Boolean(mPro?.discount_period >= 0)) {
                            prodisType = 'discount';
                        }
                        if (Boolean(mPro?.coupon_info?.discount_period >= 0)) {
                            prodisType = 'code';
                        }
                    }
                    // pre plan
                    if (Boolean(mPre?.discount_period >= 0) && Boolean(mPre?.coupon_info?.discount_period >= 0)) {
                        if (!Boolean(Number(mPre['coupon_info']['rate'])) && Number(mPre['coupon_info']['rate']) < 0) {
                            if (Number(mPre['discount_price']) >= 0) {
                                predisType = 'discount';
                            }
                        } else if (Number(mPre['coupon_info']['rate']) >= 0 && Number(mPre['coupon_info']['rate']) < 1) {
                            if (Number((Number(Number(mPre['coupon_info']['rate'])) * monthPrePrice).toFixed(2)) >= Number(mPre['discount_price']) && Boolean(mPre['discount_price'] >= 0)) {
                                if (mPre.discount_period < mPre.coupon_info.discount_period) {
                                    predisType = 'code';
                                } else {
                                    predisType = 'discount';
                                }
                            } else {
                                predisType = 'code';
                            }
                        } else if (Number(mPre['coupon_info']['rate']) >= 1) {
                            if (Number(monthPrePrice - Number(mPre['coupon_info']['rate'])) >= Number(mPre['discount_price']) && Boolean(mPre['discount_price'] >= 0)) {
                                if (mPre.discount_period < mPre.coupon_info.discount_period) {
                                    predisType = 'code';
                                } else {
                                    predisType = 'discount';
                                }
                            } else {
                                predisType = 'code';
                            }
                        } else {
                            predisType = '';
                        }
                    } else {
                        if (Boolean(mPre?.discount_period >= 0)) {
                            predisType = 'discount';
                        }
                        if (Boolean(mPre?.coupon_info?.discount_period >= 0)) {
                            predisType = 'code';
                        }
                    }
                    if (Boolean(monthPlan[1]?.coupon_info?.expires_in) && predisType === 'code') {
                        this.setState({
                            preMRecode: monthPlan[1].coupon_info.code
                        })
                    }
                    if (Boolean(monthPlan[0]?.coupon_info?.expires_in) && prodisType === 'code') {
                        this.setState({
                            proMRecode: monthPlan[0].coupon_info.code
                        })
                    }
                })
            } else {
                this.props.toggleToast(response.msg, true);
            }
        } else {
            setTimeout(() => {
                this.getUserPricingPlanList(cache);
            }, 500)
        }
    }

    // 开关弹窗
    closeCompareModal = () => {
        let { upgradeBtn } = this.state;
        if (!Boolean(upgradeBtn)) {
            this.setState({
                upgradeModalShow: false
            }, () => {
                this.props.changeUpgradeState();
            })
        }
    }

    // 切换版本套餐
    handleUpdatePricingMeal = (type) => {
        // 判断是否cw组合付费用户
        let isComboUser = store.getState().public.isComboUser;
        if (isComboUser) {
            // cw组合付费用户
            this.setState({
                isShowCwComboModal: true
            })
        } else {
            this.setState({
                upgradeBtn: type
            }, async () => {
                let { proPrice, prePrice, proId, preId, proDiscount, preDiscount, proDiscountPrice, preDiscountPrice } = this.state;
                // 计算最后的提交价格
                let endPrice = 0;
                let isGetDiscount = false;
                let isGetCodeDiscount = false;
                let disObject = {
                    discount: type === 'pro' ? proDiscount : preDiscount,
                    actMealDiscount: type === 'pro' ? proDiscountPrice : preDiscountPrice,
                }
                let price = type === 'pro' ? proPrice : prePrice;
                let id = type === 'pro' ? proId : preId;
                // 判断优惠力度
                if (!Boolean(disObject.discount) && (Number(disObject.discount) < 0 || isNaN(disObject.discount))) {
                    // 优惠折扣
                    if (disObject.actMealDiscount > 0) {
                        endPrice = disObject.actMealDiscount;
                        isGetDiscount = true;
                    } else {
                        endPrice = price;
                    }
                } else if (Number(disObject.discount) >= 0 && Number(disObject.discount) < 1) {
                    if (Number((Number(Number(disObject.discount)) * price).toFixed(2)) >= disObject.actMealDiscount && Boolean(disObject.actMealDiscount >= 0)) {
                        endPrice = disObject.actMealDiscount;
                        isGetDiscount = true;
                    } else {
                        endPrice = Number((Number(Number(disObject.discount)) * price).toFixed(2));
                        isGetCodeDiscount = true;
                        // endPrice = price;
                    }
                } else if (Number(disObject.discount) >= 1) {
                    if (Number(price - Number(disObject.discount)) >= disObject.actMealDiscount && Boolean(disObject.actMealDiscount >= 0)) {
                        endPrice = disObject.actMealDiscount;
                        isGetDiscount = true;
                    } else {
                        endPrice = Number(price - Number(disObject.discount));
                        isGetCodeDiscount = true;
                        // endPrice = price;
                    }
                } else {
                    endPrice = price;
                }

                // 获取套餐来源
                const _params = {
                    source_type: "other",
                    planRes: this.state.pricingData,
                    planInfo: this.state.planInfo,
                    selData: type === 'pro' ? this.state.planInfo?.pro : this.state.planInfo?.pre,
                }
                let _t = this.props.handleGetPlanSource('enter_checkout', _params);

                let params = {
                    ppid: id,
                    price: Number(endPrice),
                    is_verify: 0,

                    source_type: _t.source_type,
                    source_position: _t.source_position,
                    plan_type: _t.plan_type,
                    plan_version: _t.plan_version,
                    discount: _t.discount,
                    paid_type: _t.paid_type,
                }
                if (isGetDiscount) {
                    // 活动折扣
                    let ppList = this.state.pricingPlanList;
                    let list_plan = [...ppList['free'], ...ppList['month'], ...ppList['year']];
                    params['activity_id'] = list_plan.filter(item => item.id === id)[0].activity_id;
                }
                if (isGetCodeDiscount) {
                    // 优惠券折扣
                    let { proMRecode, preMRecode, proYRecode, preYRecode } = this.state;
                    params['coupon_code'] = id === 2 ? proMRecode : id === 4 ? preMRecode : id === 8 ? proYRecode : id === 9 ? preYRecode : proMRecode;
                }

                // posthog 弹窗埋点
                this.props.cwreportCustomBehavior('enter_checkout', _params);

                const res = await reqGetSubscription(params);
                if (res.ack === 1) {
                    this.props.toggleToast(res.msg, false);
                    //跳转支付页面
                    let j_url = res.data.jump_url;
                    if (j_url) {
                        if (window.top) {
                            window.top.location.href = j_url;
                        } else {
                            this.handleJumpSubUrl(j_url);
                        }
                    }
                } else {
                    // 老用户一次性付费
                    if (res.code === 202) {
                        this.setState({
                            upgradeBtn: false
                        })
                    } else {
                        this.setState({
                            upgradeBtn: false,
                        }, () => {
                            this.props.toggleToast(res.msg, true);
                        })
                    }
                }
            })
        }
    }

    // 监听支付跳转
    handleJumpSubUrl = (j_url) => {
        if (window.top) {
            window.top.location.href = j_url;
        } else {
            setTimeout(() => {
                this.handleJumpSubUrl(j_url);
            }, 5000)
        }
    }

    // 关闭
    closeComboModal = () => {
        this.setState({
            isShowCwComboModal: false
        })
    }

    // 跳转价格页
    jumpPricing = () => {
        const url = "/plan";
        if (window.opener) {
            this.handleModalToMain(url);
        } else {
            utils.routeJump(this, url);
        }
    }

    // 跳转cw集合页
    goSolutionExpert = () => {
        const url = "/settings";
        const _query = { selected: "Solutionexpert", tabkey: 5 };
        if (window.opener) {
            this.handleModalToMain(url, null, _query);
        } else {
            utils.routeJump(this, url, null, _query);
        }
    }

    // 判断是否内嵌及退出全屏
    handleModalToMain = (url, state = null, query = null) => {
        const pathUrl = window.location.pathname;
        let modal = pathUrl.indexOf("/speedOpt/seo-ant-amp/custome") > -1 ? "AMP_Customize_Modal" :
            pathUrl.indexOf("/on-page-seo/detail") > -1 ? "OnpageAI_Modal" : null;
        // pathUrl.indexOf("/content-seo/ai-blog-generator/generate-blog") > -1 ? "OnpageBlog_Modal" : null;
        this.sendDataToMain(url, modal, state, query);
    }

    // 传递参数到主窗口
    sendDataToMain = (url, objs, _state, _query) => {
        const _winOpr = window.opener;
        if (_winOpr) {
            _winOpr.postMessage({ mode: "UpgradeOpener", url, objs, _state, _query }, window.location.origin);    // 传递数据到主窗口
        }
    }

    render() {
        const {
            upgradeModalShow,
            upgradeBtn,
            serversList,
            loading,
            userInfo,
            isCustomize,
            cusTitle,
            isShowCwComboModal,
            creditsShow,
            level
        } = this.state;

        // 路由
        const pathUrl = window.location.pathname || '';

        // cw组合套餐提示弹窗
        const CWComboModal = <Modal
            open={isShowCwComboModal}
            title={t("Plan reminder")}
            primaryAction={{
                content: t("Go to view"),
                onAction: this.goSolutionExpert,
            }}
            secondaryActions={[
                {
                    content: t("Close"),
                    onAction: this.closeComboModal
                }
            ]}
            onClose={this.closeComboModal}
        >
            <Modal.Section>
                <p>{t("You are currently using CWILL's package, please update your plan on the package page")}</p>
            </Modal.Section>
        </Modal>

        // 图标
        const getIcon = <svg width="15" height="15" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.2803 6.03033C10.5732 5.73744 10.5732 5.26256 10.2803 4.96967C9.98744 4.67678 9.51256 4.67678 9.21967 4.96967L6.25 7.93934L5.03033 6.71967C4.73744 6.42678 4.26256 6.42678 3.96967 6.71967C3.67678 7.01256 3.67678 7.48744 3.96967 7.78033L5.71967 9.53033C6.01256 9.82322 6.48744 9.82322 6.78033 9.53033L10.2803 6.03033Z" fill="#303030" />
            <path fillRule="evenodd" clipRule="evenodd" d="M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7ZM12.5 7C12.5 10.0376 10.0376 12.5 7 12.5C3.96243 12.5 1.5 10.0376 1.5 7C1.5 3.96243 3.96243 1.5 7 1.5C10.0376 1.5 12.5 3.96243 12.5 7Z" fill="#303030" />
        </svg>
        const checkIcon = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M15.7803 5.96967C16.0732 6.26256 16.0732 6.73744 15.7803 7.03033L9.28033 13.5303C8.98744 13.8232 8.51256 13.8232 8.21967 13.5303L4.96967 10.2803C4.67678 9.98744 4.67678 9.51256 4.96967 9.21967C5.26256 8.92678 5.73744 8.92678 6.03033 9.21967L8.75 11.9393L14.7197 5.96967C15.0126 5.67678 15.4874 5.67678 15.7803 5.96967Z" fill="#8A8A8A" />
        </svg>
        const checkActIcon = <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M15.7803 5.96967C16.0732 6.26256 16.0732 6.73744 15.7803 7.03033L9.28033 13.5303C8.98744 13.8232 8.51256 13.8232 8.21967 13.5303L4.96967 10.2803C4.67678 9.98744 4.67678 9.51256 4.96967 9.21967C5.26256 8.92678 5.73744 8.92678 6.03033 9.21967L8.75 11.9393L14.7197 5.96967C15.0126 5.67678 15.4874 5.67678 15.7803 5.96967Z" fill="var(--color-primary)" />
        </svg>

        // 内容返回
        const pricingMainContent = (data) => {
            return (data.func).map((item, index) => {
                return Boolean(data?.isText) ? <span key={index}>
                    {
                        item.includes("Unlimited") ? <span>
                            <span style={{ color: "#7B45EC" }}>{t("Unlimited")}</span>&nbsp;
                            {t(item.split(" ")[1])}
                        </span> :
                            item.includes("quota") ? `${t(item.split(" ")[0])} ${t("quota")}` :
                                item.includes("pages") ? `${t(item.split(" ")[0])} ${t("pages")}` :
                                    item.includes("images/month") ? `${t(item.split(" ")[0])} ${t("images/month")}` :
                                        t(item)
                    }
                </span> : <span key={index}>{Boolean(item) ? (index === 2 ? checkActIcon : checkIcon) : '-'}</span>
            })
        }

        const rocketIcon = <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.85058 6.7603L7.56341 2.2299C8.02766 1.78362 8.66839 2.03059 8.51654 2.5973L7.78182 5.3393C7.6936 5.66854 7.88548 5.93543 8.21038 5.93543H9.35612C9.84648 5.93543 9.96829 6.50765 9.56122 6.89896L4.8484 11.4294C4.38415 11.8756 3.74342 11.6287 3.89527 11.062L4.62999 8.31996C4.7182 7.99072 4.52633 7.72383 4.20143 7.72383H3.05569C2.56533 7.72383 2.44352 7.15161 2.85058 6.7603Z" fill="white" />
        </svg>
        // <svg width="13" height="20" viewBox="0 0 13 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        //     <path d="M0.975611 12.6587C0.436796 12.6587 8.13814e-07 12.2219 7.90262e-07 11.6831L6.19681e-07 7.78064C5.72576e-07 6.70301 0.873591 5.82942 1.95122 5.82942L2.43902 5.82942C2.97784 5.82942 3.41463 6.26622 3.41463 6.80503L3.41464 11.6831C3.41464 12.2219 2.97784 12.6587 2.43903 12.6587L0.975611 12.6587Z" fill="url(#paint0_linear_3358_37060)" />
        //     <path d="M11.4116 12.6587C11.9504 12.6587 12.3872 12.2219 12.3872 11.6831L12.3872 7.78064C12.3872 6.70301 11.5136 5.82942 10.436 5.82942L9.94818 5.82942C9.40937 5.82942 8.97257 6.26622 8.97257 6.80503L8.97257 11.6831C8.97257 12.2219 9.40937 12.6587 9.94818 12.6587L11.4116 12.6587Z" fill="url(#paint1_linear_3358_37060)" />
        //     <path d="M9.04726 12.7132C9.04726 16.1906 7.94508 17.6226 7.60707 17.8273C7.33671 17.9909 7.10396 17.6909 7.02149 17.4182C7.02149 18.2956 6.48629 19.0547 6.12043 19.0547C5.75458 19.0547 5.21938 18.091 5.21938 17.2136C5.13691 17.4863 4.90416 17.9909 4.6338 17.8273C4.29579 17.6226 3.1936 16.1906 3.1936 12.7132L9.04726 12.7132Z" fill="url(#paint2_linear_3358_37060)" />
        //     <path d="M3.16921 14C2.6304 14 2.1936 13.5632 2.1936 13.0244L2.1936 7.20004C2.1936 4.71076 3.3121 2.35323 5.24013 0.778673C5.79501 0.325515 6.59219 0.325515 7.14708 0.778672C9.0751 2.35322 10.1936 4.71077 10.1936 7.20004L10.1936 13.0244C10.1936 13.5632 9.75681 14 9.218 14L3.16921 14Z" fill="url(#paint3_linear_3358_37060)" />
        //     <path d="M3.48972 6.62491L4.42341 8.1512H4.45389L5.38758 6.62491H6.06975L4.85405 8.57612L6.07737 10.5273H5.39139L4.45389 9.02201H4.42341L3.48591 10.5273H2.79993L4.04421 8.57612L2.80755 6.62491H3.48972ZM6.51849 9.76515V9.28878L8.20485 6.62491H8.58023V7.32612H8.34204L7.13587 9.23542V9.26591H9.44723V9.76515H6.51849ZM8.36872 10.5273V9.62033L8.37253 9.40311V6.62491H8.93084V10.5273H8.36872Z" fill="white" />
        //     <defs>
        //         <linearGradient id="paint0_linear_3358_37060" x1="0.94851" y1="12.6587" x2="0.94851" y2="5.82942" gradientUnits="userSpaceOnUse">
        //             <stop stopColor="#FF9F4B" />
        //             <stop offset="1" stopColor="#FFDBBA" />
        //         </linearGradient>
        //         <linearGradient id="paint1_linear_3358_37060" x1="11.4387" y1="12.6587" x2="11.4387" y2="5.82942" gradientUnits="userSpaceOnUse">
        //             <stop stopColor="#FF9F4B" />
        //             <stop offset="1" stopColor="#FFDBBA" />
        //         </linearGradient>
        //         <linearGradient id="paint2_linear_3358_37060" x1="6.12043" y1="12.7132" x2="6.12043" y2="19.0547" gradientUnits="userSpaceOnUse">
        //             <stop stopColor="#FF70CB" />
        //             <stop offset="1" stopColor="#FFDEEF" />
        //         </linearGradient>
        //         <linearGradient id="paint3_linear_3358_37060" x1="6.19361" y1="4.58621" x2="6.19361" y2="14" gradientUnits="userSpaceOnUse">
        //             <stop stopColor="#8A36FF" />
        //             <stop offset="1" stopColor="#E9268E" />
        //         </linearGradient>
        //     </defs>
        // </svg>


        // 付费版本比较弹窗
        const UpgradePlanModalHtml = <Modal
            // size="large"
            open={Boolean(upgradeModalShow)}
            title={
                pathUrl.indexOf("generate-blog") > -1 ? t("Plan Comparison") :
                    isCustomize ? t(cusTitle) : upgradeModalShow === 'pro' ? t("Available in Pro") : t("Available in Pre")
            }
            primaryAction={upgradeModalShow && upgradeModalShow !== 'all' ? [
                {
                    content: (userInfo?.trial_days > 0) ? t("Try Pre for {{v1}} Days", userInfo?.trial_days) : t("Upgrade to Pre to unlock"),
                    onAction: () => this.handleUpdatePricingMeal("pre"),
                    loading: loading || Boolean(upgradeBtn === 'pre'),
                }
            ] : []}
            secondaryActions={upgradeModalShow === 'pro' ? [
                {
                    content: (userInfo?.trial_days > 0) ? t("Try Pro for {{v1}} Days", userInfo?.trial_days) : t("Upgrade to Pro to unlock"),
                    onAction: () => this.handleUpdatePricingMeal("pro"),
                    loading: loading || Boolean(upgradeBtn === 'pro'),
                },
            ] : upgradeModalShow === 'all' ? [
                {
                    content: t("Got it"),
                    onAction: this.closeCompareModal
                }
            ] : []}
            onClose={this.closeCompareModal}
        >
            <Modal.Section>
                <div className="compare_plan_main">
                    <BlockStack gap={200}>
                        {
                            creditsShow && <Banner
                                title={t("Your AI credit balance is insufficient")}
                                tone="warning"
                            >
                            </Banner>
                        }
                        <img style={{ margin: '0 0 1rem', cursor: 'pointer' }} onClick={this.jumpPricing} src="/imgs/coupon/npre_plan.png" alt='' />
                    </BlockStack>
                    <BlockStack gap={300}>
                        <div className="cp_list">
                            <div className={`cp_flex cp_title ${isCustomize ? 'cp_title_customize' : ''}`}>
                                <span className="cp_main_name"></span>
                                {
                                    isCustomize ? <>
                                        <span className="cp_name">
                                            <span className="plan_block">{t("Basic")}</span>
                                            {level === 1 ? <span className="plan_status">{t("Current Plan")}</span> : ""}
                                        </span>
                                        <span className="cp_name">
                                            <span className="plan_block">{t("Pro")}</span>
                                            {level === 2 ? <span className="plan_status">{t("Current Plan")}</span> : ""}
                                        </span>
                                        <span className="cp_name">
                                            <span className="plan_block">
                                                <span className="flex_layout">{t("Premium")} {rocketIcon}</span>
                                            </span>
                                            {level === 3 ? <span className="plan_status">{t("Current Plan")}</span> : ""}
                                        </span>
                                    </> : <>
                                        <span>{t("Basic")}</span>
                                        <span>{t("Pro")}</span>
                                        <span>{t("Pre")}</span>
                                    </>
                                }
                            </div>
                            <div className="cp_main">
                                {
                                    serversList.map(item => {
                                        return <div className="cp_flex cp_main_item" key={item.id}>
                                            {
                                                isCustomize ? <span className="cp_main_name">
                                                    <Tooltip
                                                        width={'wide'}
                                                        content={
                                                            <div className="pricing_desc_img">
                                                                <img src={item?.image} alt='' />
                                                                <img className='load_img' src='/imgs/Image/load_img.png' alt='' />
                                                                <span>{t(item?.desc)}</span>
                                                            </div>
                                                        }
                                                    >
                                                        <span className="cp_main_name_customize">{t(item.name)}</span>
                                                    </Tooltip>
                                                </span> : <span className="cp_main_name">{t(item.name)}</span>
                                            }
                                            {pricingMainContent(item)}
                                        </div>
                                    })
                                }
                            </div>
                        </div>
                    </BlockStack>
                    {
                        isCustomize ? null : <p className="get_overview">{t("Get a Complete Overview of")} <Button variant="plain" onClick={this.jumpPricing}>{t("All Plan Features")}</Button></p>
                    }
                </div>
            </Modal.Section>
        </Modal>

        return <div>
            {UpgradePlanModalHtml}
            {CWComboModal}
        </div>;
    }
}


const mapStateToProps = state => {
    return state
}
const mapDispatchToProps = dispatch => ({
    // 判断是否页面第一次loading
    getPageDataRedux(data) {
        dispatch(setPageData(['pricingPlan', data]));
    },
})

indexClass = connect(
    mapStateToProps,
    mapDispatchToProps
)(indexClass);

export default withRouter(indexClass);